import Maxio from './chargify';

window.Maxio = Maxio;
window.Chargify = Maxio;
